// extracted by mini-css-extract-plugin
export default {"editBtn":"ReviewItem_editBtn__WH8QJ","progressbar":"ReviewItem_progressbar__YWygF","reviewHeader":"ReviewItem_reviewHeader__PjuwA"};